import { Component, Input } from '@angular/core';

import { Usuario } from '../../usuario';

@Component({
    selector: 'sgt-usuario-permissao-integracao',
    templateUrl: './usuario-permissao-integracao.component.html',
    styleUrls: ['./usuario-permissao-integracao.component.less']
})
export class UsuarioPermissaoIntegracaoComponent {
    @Input() entity: Usuario;
    @Input() isPerfilRepresentante: boolean;

    /** Verifica se possui alguma opção para selecionar */
    possuiAlgumaOpcao(): boolean {
        // Usuários de perfil representante por enquanto não possui
        if (this.isPerfilRepresentante) {
            return false;
        }

        return true;
    }
}
